module.exports = __webpack_public_path__ + "img/disabled.e49456ca.svg";